import { findQueryByShape, getShape, isCachedShape } from '@takeshape/schema';
import { getRuntimeSchema } from 'app/branches/selectors';
import PermissionsWrapper from 'app/permissions/components/permissions-wrapper';
import { getResourceString } from 'app/permissions/util';
import type React from 'react';
import { useSelector } from 'react-redux';

export type ShapeListPermissionsWrapperProps = {
  readonly shapeName: string;
  readonly children?: React.ReactNode;
};

const ShapeListPermissionsWrapper: React.FC<ShapeListPermissionsWrapperProps> = ({ shapeName, children }) => {
  // Only look at the production schema since indexing and shapedb only work on production
  const projectSchema = useSelector(getRuntimeSchema);
  if (!projectSchema) {
    return null;
  }

  const shape = getShape(projectSchema, shapeName);
  if (!shape) {
    return null;
  }

  let queryName: string | undefined;
  if (isCachedShape(shape)) {
    // Currently content edit uses the search query, this will need to be updated when that uses more
    // specific queries.
    queryName = 'search';
  } else {
    const resolver = shape?.model?.type === 'single' ? 'shapedb:get' : 'shapedb:list';
    queryName = findQueryByShape(projectSchema, shapeName, resolver);
  }

  if (!queryName) {
    return null;
  }

  return (
    <PermissionsWrapper
      action="graphql:execute"
      resource={getResourceString('graphql', {
        projectId: projectSchema.projectId,
        field: `Query.${queryName}`
      })}
    >
      {children}
    </PermissionsWrapper>
  );
};

export default ShapeListPermissionsWrapper;
